export const toggleVolume = () => {
  const button = document.querySelector(".js-button-volume");
  const video = document.querySelector(".js-top-bg-video");

  if (!button || !video) {
    return;
  }

  const icon = button.querySelector(".c-button-volume__icon use");
  if (!icon) return;

  button.addEventListener("click", () => {
    if (video.muted) {
      video.muted = false;
      icon.setAttribute("href", "#icon-volume");
      button.setAttribute("aria-label", "メインビジュアルの音声をミュートにする");
    } else {
      video.muted = true;
      icon.setAttribute("href", "#icon-mute");
      button.setAttribute("aria-label", "メインビジュアルの音声を再生する");
    }
  });
};
